import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/** `eventName` matches the `type` of the actions dispatched by `Application/Sso/**`. */
const SsoNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="IDENTITY_PROVIDER_SAVED"
				title="Configuration enregistrée"
				message="La configuration du fournisseur d’identité a bien été enregistrée."
			/>
			<ErrorNotification
				eventName="IDENTITY_PROVIDER_SAVE_FAILED"
				title="Erreur"
				message="La configuration n’a pas pu être enregistrée."
			/>
			<SuccessNotification
				eventName="IDENTITY_PROVIDER_DELETED"
				title="Configuration supprimée"
				message="La configuration du fournisseur d’identité a bien été supprimée."
			/>
			<ErrorNotification
				eventName="IDENTITY_PROVIDER_DELETION_FAILED"
				title="Erreur"
				message="La configuration n’a pas pu être supprimée."
			/>
			<SuccessNotification
				eventName="CONNECTION_TESTED"
				title="Test de connexion"
				message="Le test de connexion a été effectué."
			/>
			<ErrorNotification
				eventName="CONNECTION_TEST_FAILED"
				title="Test de connexion"
				message="Le test de connexion n’a pas pu être effectué."
			/>
		</React.Fragment>
	);
};

export default SsoNotifications;
